import {ISegmentationImageDto, SegmentationImage} from "@/modules/Segmentation/models/SegmentationImage";
import {ISegmentationImageService} from "@/modules/Segmentation/services/ISegmentationImageService";
import {inject, injectable} from "tsyringe";
import {IHttpService} from "frontend-core";
import {IPaginationDto, IPaginationModel} from "@/models/Pagination";

@injectable()
export class SegmentationImageService implements ISegmentationImageService {
    constructor(
        @inject("IHttpService")
        private readonly http: IHttpService,
    ) {
    }

    async get(agentId: string, page: number, countPerPage: number = 20): Promise<IPaginationModel<SegmentationImage>> {
        let array: SegmentationImage[] = [];
        let count = 0;

        await this.http.api.get<ISegmentationImageHydra>(
            `/segmentation_histories?agent=${agentId}&page=${page}&pagination=true`,
            {
                headers: {
                    "Accept": "application/ld+json"
                }
            }
        )
            .then((data) => {
                array = data.data["hydra:member"].map(i => new SegmentationImage(i));
                count = Math.ceil(data.data["hydra:totalItems"] / countPerPage);
            })
            .catch(() => {
                array = [];
            });

        return {
            items: array,
            pagesCount: count,
        };
    }

    async getImage(imageId: string): Promise<SegmentationImage | null> {
        let segmentationImage: SegmentationImage | null = null;

        await this.http.api.get<ISegmentationImageDto>(`/segmentation_histories/${imageId.replace("/api/segmentation_histories/", "")}`)
            .then((data) => {
                segmentationImage = new SegmentationImage(data.data);
            })
            .catch(() => {
                segmentationImage = null;
            });

        return segmentationImage;
    }
}

export type ISegmentationImageHydra = IPaginationDto<ISegmentationImageDto>;
